import API from './index';

const api = {
    getEmailTemplates() {
        return API.authAPI({
            url: '/email-template/get-email-template-list',
            method: 'GET',
            params: null,
        });
    },
    updateEmailTemplate(data) {
        return API.authAPI({
            url: '/email-template/update-template',
            method: 'POST',
            data,
        });
    },

};

export default api;
